module.exports = __webpack_public_path__ + "img/platform.8ad4502.webp";